import React from 'react';
import { Check } from 'lucide-react';

const JobHeaderDDJobTypes = ({ items = [], selectedOptions = [], setSelectedOptions = () => {} }) => {
    const toggle = (value) => {
        setSelectedOptions(
            selectedOptions.includes(value)
                ? selectedOptions.filter(v => v !== value)
                : [...selectedOptions, value]
        );
    };

    return (
        <div className="flex flex-wrap gap-2">
            {items.map(item => {
                const active = selectedOptions.includes(item.value);
                return (
                    <button
                        key={item.value}
                        type="button"
                        onClick={() => toggle(item.value)}
                        className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-[13px] font-medium border transition-all ${
                            active
                                ? 'bg-[#EEF1FE] border-[#3F57E0] text-[#3F57E0]'
                                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        {active && <Check className="w-3 h-3 shrink-0" />}
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default JobHeaderDDJobTypes;
